export const environment = { production: true, apiUrl: 'https://form-engine.k8qa.myafsa.com/api' };
